import { FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { styled } from '@mui/system';
import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { VyIcon } from '@vy/ui-design-system';
import { ControlledTextInput } from '../../../components/ControlledTextInput';
import type { PaddleRegisterControl } from '../PaddleRegisterFormSchema';

interface PaddleRegistrationFormProps {
  control: PaddleRegisterControl;
}

export const PaddleRegistrationForm: FC<PaddleRegistrationFormProps> = ({ control }) => (
  <FormContainer>
    <VyIcon icon="PaddleLogoIcon" style={{ width: 120, height: 60 }} />
    <Typography variant="h4">Enter your Paddle API key to get started</Typography>
    <ControlledTextInput
      name="apiToken"
      control={control}
      label="API Key"
      placeholder="Enter API Key here..."
      defaultValue=""
    />
    <Controller
      name="environment"
      control={control}
      defaultValue="production"
      render={({ field }) => (
        <FormControl fullWidth>
          <InputLabel>Environment</InputLabel>
          <Select {...field} label="Environment">
            <MenuItem value="production">Production</MenuItem>
            <MenuItem value="sandbox">Sandbox</MenuItem>
          </Select>
        </FormControl>
      )}
    />
    <Typography
      variant="subtitle2"
      sx={{ color: '#3A78F8', cursor: 'pointer' }}
      onClick={() => window.open('https://developer.paddle.com/api-reference/overview')}
    >
      Where can I find my key?
    </Typography>
  </FormContainer>
);

const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
});
